exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "/* @media(max-width: 768px){\n \n.greeting{\n  padding-left: 0 !important;\n  padding-top: 12vh !important;\n  font-size: 4em !important;\n}\n\n}\n\n@media(max-width:500px){\n\n.greeting{     \n  font-size: 3em !important;\n}\n\n}\n\n\n@media(max-width:320px){\n\n.greeting{     \n  font-size: 2.70em !important;\n}\n\n} */", ""]);

